import { render, staticRenderFns } from "./FingerprintAuthorization.vue?vue&type=template&id=d13cf2b2&scoped=true&"
import script from "./FingerprintAuthorization.vue?vue&type=script&lang=js&"
export * from "./FingerprintAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./FingerprintAuthorization.vue?vue&type=style&index=0&id=d13cf2b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13cf2b2",
  null
  
)

export default component.exports